export default "__VITE_ASSET__oMUx_XKh__"